import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { TranslocoService } from '@jsverse/transloco';
import { Navigation } from 'app/core/navigation/navigation.types';
import { map, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private _httpClient = inject(HttpClient);
    private _translocoService = inject(TranslocoService);
    private _navigation: ReplaySubject<Navigation> =
        new ReplaySubject<Navigation>(1);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            map((navigation) => ({
                compact: this._translate(navigation.compact),
                default: this._translate(navigation.default),
                futuristic: this._translate(navigation.futuristic),
                horizontal: this._translate(navigation.horizontal),
            })),
            tap((navigation) => {
                this._navigation.next(navigation);
            })
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    //Troca o título dos itens com meta.titleKey pelo texto do idioma ativo.
    //O dicionário já está carregado: o initializer do Transloco roda antes
    //do resolver que busca o menu.
    private _translate(items: FuseNavigationItem[] = []): FuseNavigationItem[] {
        return items.map((item) => ({
            ...item,
            title: item.meta?.titleKey
                ? this._translocoService.translate(item.meta.titleKey)
                : item.title,
            ...(item.children
                ? { children: this._translate(item.children) }
                : {}),
        }));
    }
}
